var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:({'color':_vm.color})},[_c('FeatherIcon',{attrs:{"icon":_vm.featherIcon,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }